// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".remark[data-v-37b7a8a3]{font-size:12px;padding-top:10px;color:#999}", ""]);
// Exports
module.exports = exports;
